// extracted by mini-css-extract-plugin
export var locationCard = "_ef-0";